import { BiCheck } from "react-icons/bi";

import Button, { ButtonStyle } from "components/Button";

const ApplicationFooter = ({
  completedButtonLabel,
  completedButtonDisabled,
  onClickCompletedButton,
  subButtonConfig,
}: {
  completedButtonLabel: string;
  onClickCompletedButton?: () => void;
  completedButtonDisabled?: boolean;
  subButtonConfig?: {
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
    isShowRequestEdit?: boolean;
  };
}) => {
  return (
    <div className="fixed bottom-0 left-0 z-10 flex h-[64px] w-full items-center justify-end bg-white shadow-top-md">
      {subButtonConfig != null && subButtonConfig.isShowRequestEdit && (
        <Button
          text={subButtonConfig.label}
          style={ButtonStyle.OUTLINE}
          width="w-[224px]"
          onClick={() => subButtonConfig.onClick()}
          isDisabled={subButtonConfig.isDisabled}
        />
      )}
      <div className="ml-4 mr-[83px]">
        <Button
          text={completedButtonLabel}
          style={ButtonStyle.PRIMARY}
          onClick={() => onClickCompletedButton && onClickCompletedButton()}
          width={completedButtonDisabled ? "w-[160px]" : "w-[169px]"}
          preElement={<BiCheck size={"22px"} />}
          isDisabled={completedButtonDisabled}
        />
      </div>
    </div>
  );
};

export default ApplicationFooter;
